export const showToast = (
  message: string,
  variant?: 'success' | 'error' | 'warning' | 'info',
): void => {
  if (typeof window !== 'undefined' && window.showToast) {
    window.showToast(message, variant);
  } else {
    console.error('ToastManager is not initialized yet.');
  }
};
